export default __webpack_public_path__ + "static/media/left-rock.e37ebdc5.png";